<script>
	// MenuCategories - Adaptable Component
	const MenuCategories = (resolve) => {
		require.ensure([], () => {
			resolve(require('./MenuCategories/MenuCategories'));
		});
	};
	const MenuCategoriesAnchored = (resolve) => {
		require.ensure([], () => {
			resolve(require('./MenuCategories/MenuCategoriesAnchored'));
		});
	};
	export default {
		data() {
			return {
				useComponent: 'MenuCategories',
				adapter: {},
			};
		},
		computed: {
			getComponent() {
				const componentMap = (useComponent) => {
					switch (useComponent) {
						case 'MenuCategories':
							return MenuCategories;
						case 'MenuCategoriesAnchored':
							return MenuCategoriesAnchored;
						case 'null':
							return null;
						default:
							return MenuCategories; // default component
					}
				};
				const useComponent = this.useComponent;
				return componentMap(useComponent);
			}
		},
		methods: {
			setupComponent() {
				const screen = this.$mq === 'mobile' ? 'mobile' : 'desktop';
				const useComponent = this.$layouts.getComponent({
					screen,
					route: this.$route.name,
					adapter: 'MenuCategories',
				});
				this.adapter = {
					screen,
					route: this.$route.name,
					adapter: useComponent,
				};
				this.useComponent = useComponent;
			},
		},
		created() {
			this.setupComponent();
		},
		watch: {
			$mq(newValue, oldValue) {
				if (newValue !== oldValue) {
					this.setupComponent();
				}
			}
		}
	}
</script>

<template>
	<div class="menu-categories-wrapper">
		<component :is="getComponent" :adapter="adapter">
		</component>
	</div>
</template>


// WEBPACK FOOTER //
// src/components/menu/Adapter_MenuCategories.vue